'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
import { DEFAULT_LOCALE } from "../locales/enUS.mjs";
import { PickerAdapterContext } from "../LocalizationProvider/LocalizationProvider.mjs";
export const useLocalizationContext = () => {
  const localization = React.useContext(PickerAdapterContext);
  if (localization === null) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI X: Can not find the date and time pickers localization context.
It looks like you forgot to wrap your component in LocalizationProvider.
This can also happen if you are bundling multiple versions of the \`@mui/x-date-pickers\` package` : _formatErrorMessage(149));
  }
  if (localization.adapter === null) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI X: Can not find the date and time pickers adapter from its localization context.
It looks like you forgot to pass a \`dateAdapter\` to your LocalizationProvider.` : _formatErrorMessage(150));
  }
  const localeText = React.useMemo(() => _extends({}, DEFAULT_LOCALE, localization.localeText), [localization.localeText]);
  return React.useMemo(() => _extends({}, localization, {
    localeText
  }), [localization, localeText]);
};
export const usePickerAdapter = () => useLocalizationContext().adapter;